import { JsonObject, JsonProperty } from 'json2typescript';

import { AssistantsInterface } from '../../../core';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';

@JsonObject('Assistants')
export class Assistants implements AssistantsInterface {
    @JsonProperty('ClientId', StringAdapter, true)
    private _clientId: string = undefined;

    @JsonProperty('Checked', Boolean, true)
    private _checked: boolean = undefined;


    get ClientId(): string {
        return this._clientId;
    }

    set ClientId(value: string) {
        this._clientId = value;
    }

    get Checked(): boolean {
        return this._checked;
    }

    set Checked(value: boolean) {
        this._checked = value;
    }

}
